import React from "react";
import { Form, Input, Row, Col, message, Image, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import apiCall from "../common/apiCall";

import createApp from "@shopify/app-bridge";
import { getSessionToken } from "@shopify/app-bridge-utils";

const createSessionToken = async (host) => {
  let api_key = process.env.REACT_APP_PARTNERAPP_APIKEY;
  if (host) {
    const app = createApp({
      apiKey: api_key,
      host: host
    });
    const sessionToken = await getSessionToken(app);
    return sessionToken;
  } else {
    return false;
  }
};

message.config({
  maxCount: 1
});

export default class Contents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryColor: "",
      secondaryColor: "",
      image: "",
      shopLogo: "",
      loading: true
    };
  }

  fileToBase64 = (file) =>
    new Promise((resolve) => {
      var fReader = new FileReader();
      fReader.readAsDataURL(file);
      fReader.onloadend = function (event) {
        var img = {};
        img.src = event.target.result;
        resolve(img.src.split("base64,")[1]);
      };
    });

  uploadLogo = async () => {
    var { image } = this.state;
    const img = image;
    if (!img) {
      message.warning("Please select an image");
      return;
    } else if (img.type !== "image/jpg" && img.type !== "image/png" && img.type !== "image/svg+xml") {
      message.warning("Supported file types - png, jpg, svg");
      return;
    }

    let fileEx = img.name.split(".");
    fileEx = fileEx[fileEx.length - 1];
    let base64img = await this.fileToBase64(img);
    const data = {
      logo: base64img,
      token: await createSessionToken(this.state.host),
      fileExtension: fileEx,
      type: img.type
    };
    try {
      this.setState({ loading: true });
      let response = await apiCall.post("uploadLogoandSaveColor", data);
      if (response.data.status) {
        message.success("Updated!");
        this.fetchData();
      } else {
        message.error("Some error occured!");
        this.setState({ loading: false });
      }
    } catch (error) {
      message.error("Some error occured! Please reload the page!");
      console.log(error.response ? error.response.data : error);
      this.setState({ loading: false });
    }
  };

  saveColors = async () => {
    var { primaryColor, secondaryColor } = this.state;
    if (!primaryColor || !secondaryColor) {
      message.warning("Please select colors");
      return;
    }
    const data = {
      token: await createSessionToken(this.state.host),
      colors: {
        primary: primaryColor,
        secondary: secondaryColor
      }
    };
    try {
      this.setState({ loading: true });
      let result = await apiCall.post("uploadLogoAndSaveColor", data);
      if (result.data.status) {
        message.success("Updated!");
        this.setState({ loading: false });
      } else {
        message.error("Some error occured!");
        this.setState({ loading: false });
      }
    } catch (error) {
      message.error("Some error occured! Please reload the page!");
      console.log(error.response ? error.response.data : error);
      this.setState({ loading: false });
    }
  };

  fetchData = async () => {
    try {
      this.setState({ loading: true });
      let getData = await apiCall.post("getStoreData", { token: await createSessionToken(this.state.host) });
      if (getData.data.status) {
        this.setState({
          shopLogo: getData.data.shopLogo,
          primaryColor: getData.data.primaryColor,
          secondaryColor: getData.data.secondaryColor
        });
        this.setState({ loading: false });
      } else {
        message.error("Some issue occured!");
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error.response ? error.response.data : error);
      message.error("Some error occured! Please reload the page!");
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    let token = this.props.data ? this.props.data.token : "";
    this.setState({ host: token }, () => {
      this.fetchData();
    });
  }

  render() {
    let { primaryColor, secondaryColor, shopLogo, loading } = this.state;
    return (
      <React.Fragment>
        {loading ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
            <Spin />
          </div>
        ) : (
          <div
            className="contact-details content-update"
            style={{ background: "#fff", boxShadow: "0 8px 32px rgb(47 60 74 / 1%)" }}>
            <div className="heading-page">
              <Row>
                <Col span={24}>
                  <div className="title">
                    <h2>
                      <b>Content</b>
                    </h2>
                    <p>Please upload your brand logo and select 2 colours to use in the mobile app for your store</p>
                  </div>
                </Col>
              </Row>
            </div>
            <Row align="center">
              <Col md={8} xl={8}>
                <div className="form-wrapper" style={{ textAlign: "center" }}>
                  {shopLogo ? (
                    <Image
                      width={200}
                      height={200}
                      src={shopLogo}
                      fallback="data:image/png;base64,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"
                    />
                  ) : (
                    <FontAwesomeIcon icon="cloud-upload-alt" className="icon-upload" />
                  )}{" "}
                  <h5>Upload a logo and select colors</h5>
                  <div className="form-thumbnail">
                    <Form method="post">
                      <Form.Item>
                        <Input
                          onChange={(e) => {
                            this.setState({ image: e.target.files[0] });
                          }}
                          type="file"
                          placeholder="Contact Me"
                          style={{ lineHeight: "30px" }}
                        />
                      </Form.Item>
                      <Form.Item style={{ width: "100%", textAlign: "center" }}>
                        <button
                          onClick={() => {
                            this.uploadLogo();
                          }}
                          className="dashbtn"
                          style={{ width: "100%" }}>
                          Upload
                        </button>
                      </Form.Item>
                    </Form>
                    <Form method="post">
                      <Row>
                        <Col sm={8} style={{ marginRight: "auto" }}>
                          <Form.Item>
                            <Input
                              type="color"
                              value={primaryColor}
                              onChange={(e) => {
                                this.setState({ primaryColor: e.target.value });
                              }}
                            />
                            <h6>Primary Color </h6>
                          </Form.Item>
                        </Col>
                        <Col sm={8} style={{ marginLeft: "auto" }}>
                          <Form.Item>
                            <Input
                              type="color"
                              value={secondaryColor}
                              onChange={(e) => {
                                this.setState({ secondaryColor: e.target.value });
                              }}
                              style={{ width: "100%" }}
                            />
                            <h6>Secondary Color</h6>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item style={{ width: "100%", textAlign: "center" }}>
                        <button
                          onClick={(e) => {
                            this.saveColors();
                          }}
                          className="dashbtn"
                          style={{ width: "100%" }}>
                          Save Colors
                        </button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </React.Fragment>
    );
  }
}
